import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeConfiscationTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeConfiscationTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeConfiscationTransformer.translate = translateService;
}
this.BackOfficeConfiscationTransformerKey = null;
this._key = this.BackOfficeConfiscationTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeConfiscationTransformerKey:any;
get BackOfficeConfiscationTransformerKey(): any {
    return this._BackOfficeConfiscationTransformerKey;
  }
set BackOfficeConfiscationTransformerKey(value: any) {
    this._BackOfficeConfiscationTransformerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeConfiscationTransformerKey == null || $this.BackOfficeConfiscationTransformerKey == 0;
            }


}